const nestedAccordian = {
  accordian: document.getElementById("accordian") as HTMLElement | undefined,
  accTrigger: document.getElementById("accTrigger") as HTMLElement | undefined,
  plus: `<svg>
  <use xlink:href="#plus-regular"></use>
  </svg>`,
  minus: `<svg >
  <use xlink:href="#minus-regular"></use>
  </svg>`,
  scrollToEl: undefined as HTMLElement | undefined,
  init() {
    this.setMainAccordian();
    this.setAccordian()
    this.setIcons()
  },
  setMainAccordian() {
    this.accTrigger?.addEventListener("click", () => {
        this.setItem(this.accTrigger!)
    });
  },
  setAccordian() {
    if(!this.accordian) return
    const accordian = this.accordian.querySelectorAll('.jsAccordianItem') as NodeListOf<HTMLElement>

    accordian.forEach((item) => {
        item.addEventListener('click', ()=>{
            const icon = item.querySelector('.jsAccIcon') as HTMLElement
           const {height, add} = this.setItem(item)     
           if(add){
            this.accordian!.style.maxHeight = this.accordian!.offsetHeight + height + 'px'
            icon.innerHTML = this.plus
           }else{
            this.accordian!.style.maxHeight = this.accordian!.offsetHeight - height + 'px'
            icon.innerHTML = this.minus
           }
        })     
    });
  },
  setItem(item: HTMLElement): {height: number, add: boolean}{
    const parent = item.parentElement as HTMLElement;
      const sibiling = item.nextElementSibling as HTMLElement;
      const sibilingHeight = sibiling.offsetHeight;
      const height = item.offsetHeight;
      if (item.dataset.open === "false") {
        parent.style.maxHeight = height + sibilingHeight + "px";
        item.classList.add("activeClass");
        item.dataset.open = 'true'
        return {height: sibilingHeight, add: true}
      }else{
        parent.style.maxHeight = height + "px";
        item.dataset.open = "false"
        item.classList.remove("activeClass");
        return {height: sibilingHeight , add: false}
      }

  },
  setIcons(){
    if(!this.accordian) return
    const icons = this.accordian.querySelectorAll('.jsAccIcon') as NodeListOf<HTMLElement>
  
    icons.forEach(item=>  item.innerHTML = this.plus )
  }
};

export default nestedAccordian;
